/** C-Suite roles for department reporting_branch (Settings / Org Admin → Reports To). */
export const C_SUITE_REPORTING_ROLES = [
  'CEO',
  'COO',
  'CFO',
  'CLO',
  'CCO',
  'CHRO',
  'CSO',
  'CTO',
  'CMO',
];

/** @type {Record<string, { title: string, scope: string }>} */
export const C_SUITE_ROLE_META = {
  CEO: {
    title: 'Chief Executive Officer',
    scope: 'Company-wide leadership',
  },
  COO: {
    title: 'Chief Operating Officer',
    scope: 'Operations and day-to-day execution',
  },
  CFO: {
    title: 'Chief Financial Officer',
    scope: 'Finance, accounting, and treasury',
  },
  CLO: {
    title: 'Chief Legal Officer',
    scope: 'Legal affairs and compliance counsel',
  },
  CCO: {
    title: 'Chief Compliance Officer',
    scope: 'Regulatory compliance and risk controls',
  },
  CHRO: {
    title: 'Chief Human Resources Officer',
    scope: 'People, talent, and HR policy',
  },
  CSO: {
    title: 'Chief Strategy Officer',
    scope: 'Corporate strategy and growth planning',
  },
  CTO: {
    title: 'Chief Technology Officer',
    scope: 'Technology, systems, and engineering',
  },
  CMO: {
    title: 'Chief Marketing Officer',
    scope: 'Marketing, brand, and customer growth',
  },
};

export const normalizeCSuiteRoleCode = (value) => String(value || '').trim().toUpperCase();

export const getCSuiteRoleMeta = (value) => {
  const code = normalizeCSuiteRoleCode(value);
  if (!code) return null;
  const known = C_SUITE_ROLE_META[code];
  if (known) {
    return { code, title: known.title, scope: known.scope };
  }
  return { code, title: code, scope: null };
};

export const buildReportingBranchOptions = (existingValue = '') => {
  const value = String(existingValue || '').trim();
  const roles = [...C_SUITE_REPORTING_ROLES];
  if (value && !roles.includes(value)) {
    roles.unshift(value);
  }
  return roles.map((role) => {
    const meta = getCSuiteRoleMeta(role);
    return {
      label: meta?.title ? `${meta.title} (${meta.code})` : role,
      value: role,
    };
  });
};
